import { setSafe } from "../../../util/storeHelper";
import * as actions from "../actions";
const persistentReducer = {
    reducers: {
        [actions.setSuppressSurvey]: (state, payload) => setSafe(state, ["suppressed", payload.id], payload.suppress),
    },
    defaults: {},
};
export default persistentReducer;
